export class FileSearchRecord {
    'resourceId';
    'providerResourceId';
    'resourceName';
    'resourceType';
    'path';
    'type';
    'environment';
    'cloudProvider';
    'apps';
    'tags';
    'snapshots';
    'securityInformation';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "environment",
            "baseName": "environment",
            "type": "Environment",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<FileSnapshot>",
            "format": ""
        },
        {
            "name": "securityInformation",
            "baseName": "securityInformation",
            "type": "SecurityInformation",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileSearchRecord.attributeTypeMap;
    }
    constructor() {
    }
}
